import { Component, Input, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import { PopoverInput } from './base/popover-input';
import * as moment from 'moment';


@Component({
    selector: 'popover-month',
    template: require('./popover-month.component.html')

})
export class PopoverMonthComponent extends PopoverInput  {

	constructor() { super() }

	@Input() format: string = "MMM yyyy";

	model: MonthPickerModel = new MonthPickerModel();

	onShow() {
		
		console.log("popover-month::onShow");
		
		super.onShow();
	}


	onSave(event) {
		console.log("popover-date::onSave");
		super.onSave(event);
	}



	onCancel() {
		console.log("onCancel");
		const d = moment(this.originalValue);
		
		this.selectYear(d.year());
		this.model.selectMonth(d.month());

	}

	valueChanged() {

		if (!!this.originalValue) {
			const d = moment(this.originalValue);

			this.selectYear(d.year());
			this.model.selectMonth(d.month());


		}

	}

	decrement() {
		this.model.decrementYear();
		if (this.isShowYears) {
			this.renderYears();
		}
	}

	increment() {
		this.model.incrementYear();
		if (this.isShowYears) {
			this.renderYears();
		}
	}

	selectMonth(index: number) {
		this.model.selectMonth(index);
		this.dirtyValue =
			`${this.model.selectedYearMoment.format("YYYY")}-${this.model.selectedMonthMoment.format("MM")}-01`;
	}

	isSelectedMonth(monthIndex: number) {
		return this.model.selectedMonthIndex == monthIndex && this.model.selectedMonthYear == this.model.selectedYearMoment.year();
	}


	isShowYears: boolean;
	years: Array<number> = [];
	toggleShowYears() {
		this.isShowYears = !this.isShowYears;
		this.renderYears();
	}

	renderYears() {
		this.years = [];
		for (let i = 5; i > 0; i--) {
			this.years.push(this.model.selectedYearMoment.year() - i);
		}
		for (let i = 0; i <= 6; i++) {
			this.years.push(this.model.selectedYearMoment.year() + i);
		}
	}

	selectYear(year: number) {
		this.isShowYears = false;
		this.model.selectedYearMoment = moment().year(year);
		this.model.updateYearText(); // in set get aendern
	}

	isSelectedYear(year: number) {
		return this.model.selectedYearMoment.year() === year;
	}

}


export class MonthPickerModel {
	constructor() {
		this.selectedYearMoment = moment();
		this.updateYearText();

		this.selectedMonthMoment = moment();

		this.months = moment.months();

		this.selectedMonthIndex = this.selectedMonthMoment.month();
		this.selectedMonthYear = this.selectedYearMoment.year();
	}

	selectedYearMoment: moment.Moment;
	selectedYearText: string;

	selectedMonthMoment: moment.Moment;
	selectedMonthIndex: number;
	selectedMonthYear: number;

	months: Array<string> = [];

	updateYearText() {
		this.selectedYearText = moment(this.selectedYearMoment).format('YYYY');
	}

	selectMonth(index: number) {
		this.selectedMonthMoment = moment().month(index);
		this.selectedMonthIndex = this.selectedMonthMoment.month();
		this.selectedMonthYear = this.selectedYearMoment.year();
	}

	incrementYear() {
		this.selectedYearMoment = this.selectedYearMoment.add(1, "year");
		this.updateYearText();
	}

	decrementYear() {
		this.selectedYearMoment = this.selectedYearMoment.subtract(1, "year");
		this.updateYearText();
	}
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/editable-popover/popover-month.component.ts